/**
 * Catálogo de códigos de novedad de Satrack (`eventCode`).
 *
 * Solo aplica cuando `eventSource.description === 'satrack'`. En MonitorHub y Smartelock
 * el mismo campo es texto libre del proveedor y no debe traducirse contra este catálogo.
 */
export const SatrackEvents = {
  "1": "Botón de pánico",
  "3": "Apertura o cierre de puerta",
  "11": "Vehículo encendido",
  "12": "Vehículo apagado",
  "21": "Reporte por tiempo",
  "24": "Exceso de velocidad",
  "26": "Conexión antena GPS",
  "27": "Desconexión antena GPS",
  "28": "Batería principal conectada",
  "29": "Batería principal desconectada",
  "31": "Frenada brusca",
  "158": "Nivel de batería bajo",
  "159": "Nivel de batería alto",
  "600": "Giro repentino",
  "601": "Aceleración brusca"
};
